// MainRoutes.js
import React from 'react'
import { useRoutes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import IndexLayout from '../../layouts/index'

import { PATH, protected_routes, public_routes } from '../../data/router_path'


export default function MainRoutes() {
  const { isAuthenticated, isAuthorized, user } = useSelector(
    (state) => state.auth.data
  )

  const currentRoutes =
    isAuthenticated && isAuthorized && user ? protected_routes : public_routes
  const routes = currentRoutes.map((item) => {
    const Layout = item.path != PATH.LOGIN ? IndexLayout : React.Fragment
    return {
      path: item.path,
      element: <Layout>{item.element}</Layout>,
    }
  })
  const element = useRoutes(routes)
  return element
}
